import type { FunctionComponent } from "react";
import { useMemo } from "react";

import ContentWrapper from "~/components/ContentWrapper";
import SectionHeadingTabs from "~/components/headings/SectionHeadingTabbar";
import { SUBSECTION_PARAM_NAME, useSearchParamTab } from "~/hooks/useSearchParamTab.ts";
import ProjectRevenueReportSection
	from "~/modules/project/components/ProjectDetailsView/components/ProjectRevenueReportSection/ProjectRevenueReportSection.tsx";
import ProjectTimeTrackingsSection
	from "~/modules/project/components/ProjectDetailsView/components/ProjectsTimeTrackingsSection";
import StaffUtilisationSection
	from "~/modules/project/components/ProjectDetailsView/components/StaffUtilisationSection";
import { ProjectReportingSubsection } from "~/modules/project/types/projectViewTypes.ts";
import type { SectionHeadingTab } from "~/types/tabsTypes.ts";

type ProjectReportingSectionProps = {
	projectId: string;
};

const ProjectReportingSection: FunctionComponent<ProjectReportingSectionProps> = ({ projectId }) => {
	const [activeTabId, setActiveTabId] = useSearchParamTab<ProjectReportingSubsection>(
		SUBSECTION_PARAM_NAME,
		Object.values(ProjectReportingSubsection),
		ProjectReportingSubsection.Utilization,
	);
	const tabs = useMemo(() => {
		const tabs: SectionHeadingTab[] = [
			{
				name: "Erfassungen",
				value: ProjectReportingSubsection.TimeTrackings,
				active: activeTabId === ProjectReportingSubsection.TimeTrackings,
			},
			{
				name: "Auslastung	",
				value: ProjectReportingSubsection.Utilization,
				active: activeTabId === ProjectReportingSubsection.Utilization,
			},
			{
				name: "Umsatz",
				value: ProjectReportingSubsection.Revenue,
				active: activeTabId === ProjectReportingSubsection.Revenue,
			}];
		return tabs;
	}, [activeTabId]);

	return <ContentWrapper className="grid size-full grid-rows-[auto_1fr] overflow-hidden">
		<SectionHeadingTabs tabs={tabs}
							onTabClick={(value) => setActiveTabId(value)} />
		{activeTabId === ProjectReportingSubsection.TimeTrackings && <ProjectTimeTrackingsSection projectId={projectId} />}
		{activeTabId === ProjectReportingSubsection.Utilization && <StaffUtilisationSection projectId={projectId} />}
		{activeTabId === ProjectReportingSubsection.Revenue && <ProjectRevenueReportSection projectId={projectId} />}

	</ContentWrapper>;
};

export default ProjectReportingSection;